import { render } from "./Modal.vue?vue&type=template&id=abd78430&scoped=true&ts=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=abd78430&lang=scss&scoped=true"

import exportComponent from "/home/marcin/www/orchidea-event-services/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abd78430"]])

export default __exports__